// extracted by css-extract-rspack-plugin
export default {"spaceMedium":"20px","spaceSmall":"12px","buttonContainer":"booking-notify-host-button__buttonContainer___BXj8l"};